import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Holes from './components/Holes';
import Translator from './components/Translator';

const App = () => {
  return (
    <div className="App">
      <Header />
      <Translator />
      <Footer />

      {/* “Cheese holes”, purely for decorative purposes */}
      <Holes />
    </div>
  );
}

export default App;
